/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import {useState} from 'react';
import Analytics from '../util/Analytics';
import './Tabs.scss';

export default function Tabs(props) {
    const [selected, setSelected] = useState(0);

    function renderTab(tab, index) {
        return (
            <div
                key={`tab-${index}`}
                className={`tab ${selected === index && 'selected'}`}
                onClick={() => {
                    Analytics.trackEvent('Tabs', 'Switch', tab.title);
                    setSelected(index);
                    if (props.onSelect) {
                        props.onSelect(index);
                    }
                }}
            >
                <span>{tab.title}</span>
                {selected === index && <span className="selected-indicator" />}
            </div>
        );
    }

    function hasMultipleChildren() {
        return props.children && props.children.length && props.children.length > 0;
    }

    return (
        <div className="tabset">
            {props.titles && props.titles.length > 0 && (
                <div className="tabs">{props.titles.map((tab, index) => renderTab(tab, index))}</div>
            )}
            <div className="tab-content">{hasMultipleChildren() ? props.children[selected] : props.children}</div>
        </div>
    );
}
